let init = () => {

	$('#gallery-slider').lightGallery({
		download: false,
		mode: 'lg-fade',
		cssEasing : 'cubic-bezier(0.25, 0, 0.25, 1)',
		selector: '.gallery-slider__item-play',
		autoplayControls: false,
		zoom: false,
		scale: false,
		subHtmlSelectorRelative: true,
		showThumbByDefault: true,
		pager: false,
		youtubePlayerParams: {
			modestbranding: 1,
			showinfo: 0,
			rel: 0,
			controls: 0
		}
	});
	$(function () {
		var head = document.head || document.getElementsByTagName('head')[0];
		var imgUri = $('#img-loading').data('img');
		var styleTag = document.createElement('style');
		styleTag.type = 'text/css';
		var content = document.createTextNode(`.lg-outer .lg-item { background-image: url('${imgUri}') }`);
		styleTag.appendChild(content);
		
		head.appendChild(styleTag);
	});
}

export default{
	init
}